import type { MapPin } from './DispatchMap';

/**
 * A visit's status as a pin colour — ONE map, for every screen that draws stops.
 *
 * ⚠️ The key is `completed`, not `done`. A now-deleted `MapPage` kept its own copy of this
 * table keyed `done`, which `VISIT_STATUS` has never used — so every finished visit fell
 * through its `?? 'scheduled'` and drew BLUE on the dispatch map instead of green. The bug
 * was a SECOND COPY, not a typo, which is why this lives in `v2/map/` rather than beside
 * either caller: `/fleet`'s routes map (112) and `/schedule`'s dispatch map (114) now read
 * the same six lines, and a third screen has nothing to fork.
 *
 * ⚠️ `canceled` is `problem`, not `done`. A canceled call is not a completed one, and the
 * two states are one letter apart in the same enum.
 */
export const VISIT_PIN_TONE: Record<string, MapPin['tone']> = {
  scheduled: 'scheduled',
  en_route: 'active',
  in_progress: 'active',
  completed: 'done',
  canceled: 'problem',
};

/** The tone, with the fallback every caller was writing for itself. */
export const pinToneFor = (status: string): MapPin['tone'] =>
  VISIT_PIN_TONE[status] ?? 'scheduled';
